/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Updated_SuccessInputs */

const en_task_updated_success = /** @type {(inputs: Task_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task updated successfully`)
};

const pt_br2_task_updated_success = /** @type {(inputs: Task_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade atualizada com sucesso`)
};

/**
* | output |
* | --- |
* | "Task updated successfully" |
*
* @param {Task_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_updated_success = /** @type {((inputs?: Task_Updated_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Updated_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_updated_success(inputs)
	return pt_br2_task_updated_success(inputs)
});